export default __webpack_public_path__ + "static/media/zingPcv3@3x.2f4cdffd.png";